import template from './connectMinimized.template.html';

export default {
  template,
  bindings: {
    hasSms: '<',
    hasSmsEvents: '<',
    hasPhone: '<',
    hasPhoneEvents: '<',
    onRestoreTab: '&'
  },
controller: class controller {
    constructor() {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.isOpen = false;

      /*
       * UI Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.restoreTab = (tab) => {
        ctrl.onRestoreTab({ tab });
      };
    }
  }
};
